import { requestTemplate } from 'api';

export type ITokenDetails = { ai_can_view_document: boolean, ai_model_type: string };

const fetchEditToken = (payload: any, signal?: AbortSignal) => requestTemplate.get<any>(`/documents_editing/token/`, { params: payload, signal: signal});

const checkEditingToken = (document_editing_token: string) =>
  requestTemplate.get<ITokenDetails>(`/documents_editing/${document_editing_token}/ai_details/`);

const updateEditingToken = (document_editing_token: string, payload: ITokenDetails) =>
  requestTemplate.patch<ITokenDetails>(`/documents_editing/${document_editing_token}/ai_details/`, payload,  { params: payload });


const fetchTokenForTempLink = (payload: any, signal?: AbortSignal) => requestTemplate.get<any>(`/documents_editing/token/temp-link/`, { params: payload, signal: signal});

const hasDraft = (payload: any) => requestTemplate.get<any>(`/documents_editing/has_draft/`, { params: payload });

const documents = { 
  fetchEditToken,
  checkEditingToken,
  updateEditingToken,
  fetchTokenForTempLink,
  hasDraft,
};

export default documents;
